import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { Resource } from 'features/resourceBank/types';

type QueryParamKey = 'shared_to_id' | 'shared_by_id';

type ResourceBankQueryParams = Partial<Record<QueryParamKey, string>>;

export const useResourceBankQuery = (params: ResourceBankQueryParams) => {
  const { request } = useQueryHTTPRequest();

  const queryParams = new URLSearchParams(params);

  return useQuery<{ items: Resource[] }, unknown, Resource[]>(
    [queryKeys.resourceBank, params],
    ({ signal }) =>
      request({
        url: `/api/resource-bank?${queryParams.toString()}`,
        signal,
      }),
    {
      select: (data) => data.items,
      enabled: Object.values(params).every(Boolean),
    }
  );
};
